module.exports = __webpack_public_path__ + "static/media/download-craneo-maxilofacial.b453c947.png";